import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import PatientTrialMatch from '../components/trials/PatientTrialMatch';
import TrialMatchList from '../components/trials/TrialMatchList';
import PatientMatchReasons from '../components/trials/PatientMatchReasons';
import TrialDetails from '../components/trials/TrialDetails';
import FilterBar from '../components/trials/FilterBar';

const ClinicalTrials = () => {
  return (
    <MainLayout 
      activeNavItem="trials"
      searchPlaceholder="Patient: James Wilson"
      notifications={3}
    >
      <div className="flex h-full">
        <div className="flex-1 p-6 overflow-auto">
          <h2 className="text-2xl font-bold mb-4">Clinical Trial Matches</h2>
          <FilterBar />
          <PatientTrialMatch />
          <TrialMatchList />
          <PatientMatchReasons />
        </div>
        <div className="w-80">
          <TrialDetails />
        </div>
      </div>
      <div className="bg-gray-200 text-gray-600 text-sm p-2 border-t border-gray-300">
        Matches updated: Today at 9:15 AM | Contact trial coordinator with one click
      </div>
    </MainLayout>
  );
};

export default ClinicalTrials;